import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useRef, useState, useMemo } from "preact/hooks";
import Checkbox from "./elements/Checkbox"
import MergedFacetValues from "./MergedFacetValues"

import { sortData } from "../helpers"
import { sizeOrder, facetConfigs } from "../config"

export default function Facet({ facet, activeFacet, handleFacetToggle }) {
    const { active, toggleActive, toggleProductFilter } = useFacet(facet)
    const [ dropdownHeight, setDropdownHeight ] = useState(0);
    const dropdownRef = useRef(null);
    const data = useMemo(() => facet.name.toLowerCase() == 'size' ? sortData(facet.data, sizeOrder, (v) => v.value) : facet.data, [facet.name, facet.data]);
    
    const desktopActive = activeFacet === facet.id;
    const isActive = window.innerWidth >= 1240 ? desktopActive : active;

    useEffect(() => {
        if(dropdownRef?.current) {
            requestAnimationFrame(() => {
                if(dropdownRef?.current) {
                    const element = dropdownRef.current;
                    const originalMaxHeight = element.style.maxHeight;
                    const originalHeight = element.style.height;
                    
                    element.style.maxHeight = 'none';
                    element.style.height = 'auto';

                    const naturalHeight = element.scrollHeight;
                    element.style.maxHeight = originalMaxHeight;
                    element.style.height = originalHeight;
                    setDropdownHeight(naturalHeight);
                }
            });
        }
    }, [ dropdownRef?.current, facet?.data ]);

    const handleClick = () => {
        if(window.innerWidth >= 1240) {
            handleFacetToggle(facet.id);
        } else {
            toggleActive();
        }
    }

    return (
        <li class="ns-facet">
            <button
                type="button"
                class="ns-facet-toggle ns-w-100 ns-flex ns-flex-nowrap ns-items-center ns-justify-between"
                data-nosto-element="facet"
                onClick={handleClick}
                aria-controls={`ns-${facet.id}-sub-menu`}
                aria-expanded={isActive}
                aria-label={`${isActive ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <h3 id={`ns-${facet.id}-title`}>
                    {facet.name}
                </h3>
                <span 
                    aria-hidden="true" 
                    role="presentation" 
                    class="ns-plus-minus-icon ns-relative"
                />
            </button>
            <div
                class="ns-facet-body"
                id={`ns-${facet.id}-sub-menu`}
                aria-labelledby={`ns-${facet.id}-title`}
                aria-hidden={!isActive}
                style={`--dropdown-height: ${dropdownHeight}px;`} // css transition
                ref={dropdownRef}
            >
                <ul class="ns-filter-list ns-list-unstyled ns-flex ns-flex-col" role="menu">
                    {data?.map(value => (facetConfigs[facet.id]?.nameMap?.[value.value] !== 'hidden' &&
                        <li
                            key={value.value}
                            class="ns-filter"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                valueName={facetConfigs[facet.id]?.nameMap?.[value.value] || value.value}
                                value={value.value}
                                selected={value.selected}
                                id={`ns-${facet.id}-${value.value.toString().toLowerCase().replace(/\s+/g, '-')}`}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                    {facetConfigs[facet.id]?.merge?.length > 0 && (
                        <MergedFacetValues 
                            mergedFacets={facetConfigs[facet.id].merge}
                        />
                    )}
                </ul>
            </div>
        </li>
    )
}
